import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import type { FormattedChatMessage } from "../../hooks/use-chat-thread-view";

interface ChatMessageBubbleProps {
  message: FormattedChatMessage;
}

export const ChatMessageBubble = memo(function ChatMessageBubble({
  message,
}: ChatMessageBubbleProps) {
  if (message.isFromCustomer) {
    return <CustomerBubble message={message} />;
  }
  return <MerchantBubble message={message} />;
});

const CustomerBubble = memo(function CustomerBubble({
  message,
}: ChatMessageBubbleProps) {
  return (
    <Flex dir="column" gap="xs" pr="5xl">
      <Text fontSize="xs" textColor="tertiary">
        {message.formattedTime}
      </Text>
      <Flex bgColor="tertiary" p="lg" radius="md" w="fit-content">
        <Text
          fontSize="sm"
          style={{ wordBreak: "break-word" }}
          textColor="primary"
        >
          {message.content}
        </Text>
      </Flex>
    </Flex>
  );
});

const MerchantBubble = memo(function MerchantBubble({
  message,
}: ChatMessageBubbleProps) {
  return (
    <Flex align="flex-end" dir="column" gap="xs" pl="5xl">
      <Text fontSize="xs" textColor="tertiary">
        {message.formattedTime}
      </Text>
      <Flex bgColor="alternate" p="lg" radius="md">
        <Text
          fontSize="sm"
          style={{ wordBreak: "break-word" }}
          textColor="white"
        >
          {message.content}
        </Text>
      </Flex>
    </Flex>
  );
});
